(function () {
  function initPopup(el) {
    if (el.dataset.hlpInit) return;
    el.dataset.hlpInit = 'true';

    var storageKey = 'hlp_dismissed_' + el.id;
    var rememberDays = parseInt(el.dataset.rememberDays, 10) || 7;
    var delay = parseInt(el.dataset.delay, 10) || 0;

    var dismissedAt = window.localStorage.getItem(storageKey);
    if (dismissedAt) {
      var elapsedDays = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
      if (elapsedDays < rememberDays) return; // still within the "don't show again" window
    }

    // Don't show again in the same session if the form was already submitted successfully
    var successEl = el.querySelector('.hlp__success');
    if (successEl) return;

    function show() {
      el.classList.add('is-visible');
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function hide(remember) {
      el.classList.remove('is-visible');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (remember) {
        window.localStorage.setItem(storageKey, Date.now().toString());
      }
    }

    el.querySelectorAll('[data-hlp-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { hide(true); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-visible')) hide(true);
    });

    window.setTimeout(show, delay);
  }

  function initAll() {
    document.querySelectorAll('.hlp').forEach(initPopup);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
